<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <!-- <jm-crumbs /> -->
          <el-tabs value="kr">
            <el-tab-pane label="韩国文案流程" name="kr"></el-tab-pane>
          </el-tabs>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">学生姓名</label>
              <el-input
                class="jm-input220"
                v-model="listInfoData.custom_name"/>
            </div>
            <div class="box-content">
              <label class="form-tit">手机号</label>
              <el-input
                class="jm-input220"
                v-model="listInfoData.tel"/>
            </div>
            <div class="box-content">
              <label class="form-tit">文案老师</label>
              <el-select
                v-model="listInfoData.crm_writer"
                class="jm-input220"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in ds.write_teacher"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">学历</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.custom_education"
                type="online"
                dict-type="education"/>
            </div>
            <div class="box-content box-content-double">
              <label class="form-tit">渠道</label>
              <jm-channel
                v-model="listInfoData.channel"
                clearable
                filterable/>
            </div>
            <div class="box-content">
              <label class="form-tit">语学院初始入学时间</label>
              <el-date-picker
                v-model="listInfoData.apply_date"
                type="month"
                value-format="yyyy-MM-dd"
                class="jm-input220"
                placeholder="请选择"/>
            </div>
            <div class="box-content">
              <label class="form-tit">大学初始入学时间</label>
              <el-date-picker
                v-model="listInfoData.apply_date1"
                type="month"
                value-format="yyyy-MM-dd"
                class="jm-input220"
                placeholder="请选择"/>
            </div>
            <div class="box-content">
              <label class="form-tit">项目类型</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.write_type"
                type="jiemo"
                dict-type="korea_school_type"/>
            </div>
            <div class="box-content">
              <label class="form-tit">项目状态</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.apply_status"
                type="jiemo"
                dict-type="korea_apply_status"/>
            </div>
            <div class="box-content">
              <label class="form-tit">免费语学院</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.free_language"
                type="dataset"
                dict-type="kr_process"
                name="booleanOptions"/>
            </div>
            <div class="box-content">
              <label class="form-tit">递交文案</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.submit_writer"
                type="dataset"
                dict-type="kr_process"
                name="booleanOptions"/>
            </div>
            <div class="box-content">
              <label class="form-tit">签证</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.visa"
                type="jiemo"
                dict-type="korea_visa"/>
            </div>
            <div class="box-content">
              <label class="form-tit">赴韩</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.go"
                type="jiemo"
                dict-type="korea_go"/>
            </div>
            <div class="box-content">
              <label class="form-tit">院校入学时间</label>
              <el-date-picker
                v-model="listInfoData.apply_info_date"
                type="month"
                value-format="yyyy-MM-dd"
                class="jm-input220"
                placeholder="请选择"/>
            </div>
            <div class="box-content">
              <label class="form-tit">入学（提前 | 延期）</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.apply_date_status"
                type="jiemo"
                dict-type="korea_apply_date_status"/>
            </div>
            <div class="box-content">
              <label class="form-tit">院校状态</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.apply_info_status"
                type="jiemo"
                dict-type="korea_apply_info_status"/>
            </div>
            <div class="box-content">
              <label class="form-tit">院校名称</label>
              <el-input
                class="jm-input220"
                v-model="listInfoData.sh_name"/>
            </div>
            <div class="box-content">
              <label class="form-tit">申请材料</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.apply_data"
                type="jiemo"
                dict-type="korea_apply_data"/>
            </div>
            <div class="box-content">
              <label class="form-tit">面试</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.interview"
                type="jiemo"
                dict-type="korea_interview"/>
            </div>
            <div class="box-content">
              <label class="form-tit">申请结果</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.apply_result"
                type="jiemo"
                dict-type="korea_apply_result"/>
            </div>
          </div>

          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => { this.doRefresh = true; }">开始查询</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetForm">重置</el-button>
          </div>

          <jm-tableList
            class="process-table"
            :url="`/index/kr_Process/pagetable`"
            :search-data="listInfoData"
            :refresh.sync="doRefresh"
          >
            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              :label="scope.label"
              property="custom_name">
              <template slot-scope="scope">
                <span>
                  <i class="green" v-if="scope.row.visa === 1">签</i>
                  <i class="blue" v-if="scope.row.go === 1">韩</i>
                  <i class="green" v-if="scope.row.free_language === 1">免</i>
                  <i class="blue" v-if="scope.row.submit_writer === 1">已递交</i>
                  {{ scope.row.custom_name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              slot="area_str"
              slot-scope="scope"
              :label="scope.label"
              property="area_str">
              <template slot-scope="scope">
                <span>{{ scope.row.pname }} {{ scope.row.cname }}</span>
              </template>
            </el-table-column>
            <el-table-column
              slot="num_list"
              slot-scope="scope"
              :label="scope.label"
              property="num_list">
              <template slot-scope="scope">
                <span>{{ scope.row.num_i }}/{{ scope.row.num_f }}/{{ scope.row.num_s }}</span>
              </template>
            </el-table-column>
            <el-table-column
              slot="firstColumn"
              type="expand">
              <template slot-scope="props">
                <div v-for="item in props.row.info_list" :key="item.id">
                  <el-row class="dropdown-text">
                    <el-col :span="5"><span>申请学校：</span>{{ item.sh_name }}</el-col>
                    <el-col :span="4"><span>初始入学时间：</span>{{ item.apply_old_date }}</el-col>
                    <el-col :span="4"><span>当前入学时间：</span>{{ item.apply_date_str }}</el-col>
                    <el-col :span="4"><span>申请状态：</span> {{ item.apply_status_str }}</el-col>
                    <el-col :span="7" v-if="item.apply_result_str"><span>申请结果：</span>{{ item.apply_result_str }}</el-col>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="220">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: 'editStudent', params: { id: scope.row.crm_id } }">
                  <el-button size="mini" type="primary">查看详情</el-button>
                </router-link>
                <router-link
                  target="_blank"
                  :to="{ path: `./processDetails/${scope.row.id}/${scope.row.crm_id}` }">
                  <el-button size="mini" type="primary">查看申请</el-button>
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import tableList from '@/components/data/tableList.vue';
// import { messageBox } from '@/utils/messagebox';
// import * as UserApi from '@/api/user.js';
import { crumbs, jmSchoolSearch, jmAreaselect, jmEducationSelect, jmDictSelect, jmChannel } from '@/components/tool/index.js';

const searchData = {
  tel: '',
  custom_name: '',
  currentAddress: null,
  custom_education: null,
  crm_writer: -1,
  channel: '',
  apply_date: '',
  apply_date1: '',
  write_type: 'null',
  apply_status: 'null',
  free_language: null,
  submit_writer: null,
  apply_info_date: [],
  sh_name: '',
  apply_info_status: 'null',
  apply_date_status: 'null',
  apply_result: 'null',
  interview: 'null',
  visa: 'null',
  go: 'null',
  apply_data: 'null',
};

export default {
  data() {
    let data = {
      doRefresh: false, // 表格刷新锁
      schoolModel: null, // 学校联系框值
      listInfoData: {}, // 表单数据
      ds: {
        write_teacher: []
      }
    };
    Object.assign(data.listInfoData, searchData);
    return data;
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
    jmSchoolSearch,
    jmAreaselect,
    jmEducationSelect,
    jmDictSelect,
    jmChannel,
  },
  beforeCreate() {

  },
  computed: {
    readonly() {
      return !this.$hasPermission([75, 76, 19, 33, 58]);
    },
  },
  methods: {
    // 清空查询条件
    resetForm() {
      Object.assign(this.listInfoData, searchData);
      this.schoolModel = null;
    },
  },
  mounted() {
    let that = this;
    this.$http
      ._post({
        url: '/index/kr_process/getDict'
      })
      .then(({ data }) => {
        that.ds = Object.assign({}, that.ds, data);
      });
  }
};
</script>
<style scoped>
  .process-table span i {
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    border-radius: 3px;
    padding:0 4px;
    margin: 0 4px;
  }
  .process-table span i.green{
    color: #67c23a;
    border: 1px solid #67c23a;
  }
  .process-table span i.blue{
    color: #409EFF;
    border: 1px solid #409EFF;
  }
  .dropdown-text span:first-of-type{
    color: #99a9bf;
  }
  .list-botton{
    margin-top:20px;
    margin-bottom: 10px;
  }
</style>
<style>
  .processlist-wrap .el-col .jm-input135{
    margin-right: 10px;
  }
</style>
